import { AppBar, Box, IconButton, Toolbar, Typography, styled, Button } from '@mui/material'
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import { LinkedIn, Mail } from '@mui/icons-material';

const MyToolbar = styled(Toolbar)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between"
}))

const Icons = styled(Box)(({ theme }) => ({
    display: "flex", gap: "5px", alignItems: "center"
}))

interface ChildProps {
    add: () => void,
    title:string
}

const NavBar = (props: ChildProps) => {

    const navigate = useNavigate()

    const checkSignIn = () => {

        if (auth.currentUser) {
            navigate('/admin')
        } else {
            props.add()
        }
    }

    return (
        <AppBar position='sticky'>
            <MyToolbar>
                <Typography variant='h6'>
                    akhilasdeveloper
                </Typography>
                <Icons>
                    <IconButton aria-label="Github" onClick={(e) => {
                        window.open("https://github.com/akhilasdeveloper", '_blank', 'noreferrer')
                    }}>
                        <GitHubIcon />
                    </IconButton>
                    <IconButton aria-label="instagram" onClick={(e) => {
                        window.open("https://instagram.com/akhilasdeveloper?igshid=YmMyMTA2M2Y=", '_blank', 'noreferrer')
                    }}>
                        <InstagramIcon />
                    </IconButton>
                    <IconButton aria-label="LinkedIn" onClick={(e) => {
                        window.open("https://www.linkedin.com/in/akhil-as-3361a8244", '_blank', 'noreferrer')
                    }}>
                        <LinkedIn />
                    </IconButton>
                    <IconButton aria-label="Mail" onClick={(e) => {
                        window.location.replace("mailto:akhilasdeveloper@gmail.com")
                    }}>
                        <Mail />
                    </IconButton>
                    
                    <Button color="secondary" onClick={checkSignIn} variant="outlined" size='small'>Admin</Button>
                </Icons>
            </MyToolbar>
        </AppBar>
    )
}
export default NavBar
